import React from 'react'
import PropTypes from 'prop-types'
import { StudentListStyle } from './style'
import StudentListItem from './StudentListItem'
import { useSortAndLabelStudentList } from '@hooks/useSortAndLabelStudentList'
import Text from '@components/Text'
import Divider from '@components/Divider'
import { DIVIDER_SIZE } from '@helpers/constants'

const StudentList = (props) => {
  const { items, updateHook, resourceId, resourceType, hideRemoveButton } =
    props
  const { students: sortedItems } = useSortAndLabelStudentList(items)

  return (
    <ul className={StudentListStyle.list}>
      {!sortedItems.length && <Text>Klassen har inga elever ännu.</Text>}
      {sortedItems?.map(({ item, label }, index) => {
        return (
          <div key={item.id}>
            <StudentListItem
              item={item}
              label={label}
              updateHook={updateHook}
              resourceId={resourceId}
              resourceType={resourceType}
              hideRemoveButton={hideRemoveButton}
            />

            {/* {index < sortedItems.length - 1 && (
              <>
                <Divider size={DIVIDER_SIZE.XSMALL} line />
                <Divider size={DIVIDER_SIZE.XSMALL} />
              </>
            )} */}
          </div>
        )
      })}
    </ul>
  )
}

StudentList.propTypes = {
  items: PropTypes.array,
  resourceId: PropTypes.string,
  resourceType: PropTypes.string,
  updateHook: PropTypes.func,
  hideRemoveButton: PropTypes.bool,
}

export default StudentList
